import { HttpErrorResponse } from '@angular/common/http';
import { GDPRService } from 'src/app/core/services/rulebook';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { DeleteDialogComponent } from '../../distributed-ui-components';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonService } from './../../../core/services/common/common.service';
import { AlertDialogModel } from '../../../core/models/view-model/alert-dialog.model';
import { SelfAssessmentFilter } from 'src/app/core/models/self-assessment/self-assessment-filter';
import { SelfAssessmentListDto } from './../../../core/models/self-assessment/self-assessment-list-dto';
import {
  SelfAssessmentT2ViewModel,
  SelfAssessmentViewModel,
} from 'src/app/core/models/self-assessment/self-assessment-view-model';
import { MatDialog } from '@angular/material/dialog';
import { Role } from 'src/app/core/models/user-management/role';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { UserProfile } from 'src/app/core/models/user';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { BulkSelfUpdateDialogComponent } from '../bulk-self-update-dialog/bulk-self-update-dialog.component';
import {
  BulkSelfAssessment,
  SelfAssessment,
} from 'src/app/core/models/self-assessment/self-assessment';
import {
  BulkSelfUpdateModel,
  BulkSelfUpdateModelT2,
} from 'src/app/core/models/self-assessment/bulk-self-update-model';
import { CopyDialogComponent } from '../../distributed-ui-components/copy-dialog/copy-dialog.component';
import { ItemActiveModel } from 'src/app/core/models/view-model/item-acive-model';
import {
  SelfAssessmentColumnModel,
  SelfAssessmentT2ColumnModel,
  SelfAssessmentT3ColumnModel,
} from 'src/app/core/models/view-model/self-assessment-column-model';
import { MasterHelper } from 'src/app/core/utilities';
import { NavigationExtras, Router } from '@angular/router';
import { GeneralDataService } from 'src/app/core/services/general/general-data.service';
import {
  SelfAssessmentNew,
  SelfAssessmentT2,
} from 'src/app/core/models/self-assessmentT2/self-assessmentT2';
import { SelfAssessmentT2ListDto } from 'src/app/core/models/self-assessmentT2/self-assessmentT2-list-dto';
import { SelfAssessmentT2Filter } from 'src/app/core/models/self-assessmentT2/seld-assessmentT2-filter';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { SelfAssessmentT3Filter } from 'src/app/core/models/self-assessmentT3/selft-assessmentT3-filter';
import {
  SelfAssessmentT3ListDto,
  SelfAssessmentT3ViewModel,
} from 'src/app/core/models/self-assessmentT3/SelfAssessmentT3ViewModel';
import { SelfAssessmentT3FilterModel } from 'src/app/core/models/self-assessmentT3/SelfAssessmentT3Filter';
import { GlobalService } from 'src/app/core/services/global/global.service';

@Component({
  selector: 'app-self-assessment-summary',
  templateUrl: './self-assessment-summary.component.html',
  styleUrls: ['./self-assessment-summary.component.scss'],
})
export class SelfAssessmentSummaryComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;
  @Output() OnFilterT3 = new EventEmitter<SelfAssessmentT3Filter>();
  @ViewChild('tableContent', { read: ElementRef })
  public tableContent: any;
  @ViewChild('tableContentT2', { read: ElementRef })
  public tableContentT2: any;
  itemActiveModel: Array<ItemActiveModel>;
  itemActiveModelT2: Array<ItemActiveModel>;
  itemActiveModelT3: Array<ItemActiveModel>;
  assesmentType = '_sacol';
  assesment2Type = '_sacol2';
  assesment3Type = '_sacol3';
  tableWidth!: number;
  tableWidthT2!: number;
  showT3Summary: boolean = true;
  selfAssessmentColumns: SelfAssessmentColumnModel;
  selfAssessmentT2Columns: SelfAssessmentT2ColumnModel;
  selfAssessmentT3ColumnModel: SelfAssessmentT3ColumnModel = new SelfAssessmentT3ColumnModel();
  selfAssessmentSummary: Array<SelfAssessmentListDto>;
  selfAssessmentT2Summary: Array<SelfAssessmentT2ListDto>;
  selectedItems: Array<number>;
  toastModel: ToastViewModel;
  isToastShow = false;
  alertDialogModel: AlertDialogModel;
  selfAssessmentFilter: SelfAssessmentFilter;
  selfAssessmentT2Filter: SelfAssessmentT2Filter;
  selfAssessmentT3FilterData: SelfAssessmentT3Filter;
  totalCount = 0;
  isTableLoaded = false;
  isLoading = false;
  newSAItemId: number;
  myInnerHeight: any;
  endIndex = 0;
  currentUserRole = '';
  receivedData: Array<any> = [];
  selfAssessmentT3Filter: SelfAssessmentT3FilterModel =
    new SelfAssessmentT3FilterModel();
  selfAssessmentList: Array<SelfAssessmentT3ListDto> = [];
  userAccessToken: UserProfile;
  bulkUpdateModel: BulkSelfUpdateModel;
  bulkUpdateModelT2: BulkSelfUpdateModelT2;
  selectedItemId = 0;
  filterPersistenceKey = 'selfAssessmentFilters';
  filterT2PersistenceKey = 'selfAssessmentT2Filters';
  oldestCreationDate: string = MasterHelper.getDateStr(30);
  isPersistFilter = false;
  isPersistT2Filter = false;
  isReset = false;
  templateNo = 1;
  divisionId!: number;
  idList: number[] = [];

  constructor(
    private gdprService: GDPRService,
    private eleRef: ElementRef,
    private selfAssessmentT3Service: SelfAssessmentTemplate3Service,
    private sessionService: SessionService,
    private impactService: ImpactService,
    public dialog: MatDialog,
    public commonService: CommonService,
    private router: Router,
    private generalService: GeneralDataService,
    private _selfAssessmentTemplate3Service: SelfAssessmentTemplate3Service,
    public _globalService: GlobalService,
  ) {
    this.myInnerHeight = window.innerHeight - 350;
    this.selfAssessmentSummary = [];
    this.selfAssessmentT2Summary = [];
    this.bulkUpdateModel = new BulkSelfUpdateModel();
    this.bulkUpdateModelT2 = new BulkSelfUpdateModelT2();
    this.selectedItems = [];
    this.toastModel = new ToastViewModel();
    this.userAccessToken = new UserProfile();
    this.alertDialogModel = new AlertDialogModel();
    this.selfAssessmentFilter = new SelfAssessmentFilter();
    this.selfAssessmentT2Filter = new SelfAssessmentT2Filter();
    this.selfAssessmentT3FilterData = new SelfAssessmentT3Filter();
    this.gdprService.tabActive = false;
    this.newSAItemId = this.fetchFromBrowser('_said')
      ? Number(this.fetchFromBrowser('_said'))
      : 0;
    if (this.newSAItemId > 0) {
      this.selectedItems.push(this.newSAItemId);
    }
    const persistFilter = JSON.parse(
      this.fetchFromBrowser(this.filterPersistenceKey) as string
    ) as SelfAssessmentFilter;
    //For Template 2
    const persistT2Filter = JSON.parse(
      this.fetchFromBrowser(this.filterT2PersistenceKey) as string
    ) as SelfAssessmentT2Filter;
    if (persistFilter) {
      this.selfAssessmentFilter = persistFilter;
      this.isPersistFilter = true;
    }
    if (persistT2Filter) {
      this.selfAssessmentT2Filter = persistT2Filter;
      this.isPersistT2Filter = true;
    }
    this.selfAssessmentColumns = new SelfAssessmentColumnModel();
    this.selfAssessmentT2Columns = new SelfAssessmentT2ColumnModel();
    this.tableWidth = 3250;
    this.tableWidthT2 = 4740;

    this.itemActiveModel = [
      { itemTitle: 'Assessment Creation Date', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessment Due Date', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessment Last Edited', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessment Status', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessment Team', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessor', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessor Delegate', itemWidth: 170, isActive: true },
      { itemTitle: 'Conclusion', itemWidth: 210, isActive: true },
      { itemTitle: 'Overall Rule Status', itemWidth: 170, isActive: true },
      { itemTitle: 'Owner', itemWidth: 170, isActive: true },
      { itemTitle: 'Review Due Date', itemWidth: 170, isActive: true },
      { itemTitle: 'Review Status', itemWidth: 170, isActive: true },
      { itemTitle: 'Review Team', itemWidth: 170, isActive: true },
      { itemTitle: 'Reviewer', itemWidth: 170, isActive: true },
      { itemTitle: 'Reviewer Delegate', itemWidth: 170, isActive: true },
    ];
    this.itemActiveModelT2 = [
      { itemTitle: 'Assessment Category', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessment Due Date', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessment Team', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessor', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessment Status', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessment Creation Date', itemWidth: 170, isActive: true },
      { itemTitle: 'Compliance Status', itemWidth: 170, isActive: true },
      { itemTitle: 'Interpretation', itemWidth: 170, isActive: true },
      { itemTitle: 'Judgements', itemWidth: 210, isActive: true },
      { itemTitle: 'No. of Judgements', itemWidth: 170, isActive: true },
      { itemTitle: 'Limitations', itemWidth: 170, isActive: true },
      { itemTitle: 'No. of Limitations', itemWidth: 170, isActive: true },
      {
        itemTitle: 'No. of Limitations Requiring Action',
        itemWidth: 170,
        isActive: true,
      },
      { itemTitle: 'Actions', itemWidth: 170, isActive: true },
      { itemTitle: 'No. of Actions', itemWidth: 170, isActive: true },
      { itemTitle: 'Risk Recommendation', itemWidth: 170, isActive: true },
      // { itemTitle: 'Risk Recommendation Status', itemWidth: 170, isActive: true },
      { itemTitle: 'Reviewer Team', itemWidth: 170, isActive: true },
      { itemTitle: 'Reviewer', itemWidth: 170, isActive: true },
      { itemTitle: 'Review Status', itemWidth: 170, isActive: true },
      { itemTitle: 'Approval Team', itemWidth: 170, isActive: true },
      { itemTitle: 'Approvers', itemWidth: 170, isActive: true },
      { itemTitle: 'Approval Status', itemWidth: 170, isActive: true },
      { itemTitle: 'Last Approved', itemWidth: 170, isActive: true },
    ];
    this.itemActiveModelT3 = [
      // { itemTitle: 'Id', itemWidth: 170, isActive: true },
      // { itemTitle: 'Rulebook', itemWidth: 170, isActive: true },
      // { itemTitle: 'Part', itemWidth: 170, isActive: true },
      // { itemTitle: 'Rule Id', itemWidth: 170, isActive: true },
      { itemTitle: 'Rule Owner', itemWidth: 170, isActive: true },
      { itemTitle: 'Compliance Status', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessment Status', itemWidth: 170, isActive: true },
      { itemTitle: 'Review Date', itemWidth: 170, isActive: true },
      { itemTitle: 'Assessment Date', itemWidth: 170, isActive: true },
      { itemTitle: 'LBG Impact', itemWidth: 170, isActive: true },
      { itemTitle: 'RFB Impact', itemWidth: 170, isActive: true },
      { itemTitle: 'LBCM Impact', itemWidth: 170, isActive: true },
      { itemTitle: 'Next Assessment Due Date', itemWidth: 170, isActive: true },
    ];
  }

  async ngOnInit(): Promise<void> {
    this.userAccessToken = await this.sessionService
      .getLoginUserInfo()
      .toPromise();
    const templateNo: number = await this.gdprService
      .getSelfAssessmentTemplate(this.userAccessToken.lastUsedJurisdictionId)
      .toPromise();
    this.templateNo = templateNo;

    if (this.templateNo == 2) {
      // Get the elements with the specified classes
      const bodyStyleElement = document.querySelector(
        '.body-style2'
      ) as HTMLDivElement;
      const tableElement = document.querySelector('.table') as HTMLDivElement;

      // Check if the elements exist
      if (bodyStyleElement && tableElement) {
        // Set the width for .body-style and .table
        bodyStyleElement.style.width = this.tableWidthT2 + 'px';
        tableElement.style.width = this.tableWidthT2 + 'px';
        bodyStyleElement.style.overflow = 'auto';
      }
      const persistColumn = JSON.parse(
        this.fetchFromBrowser(this.assesment2Type) as string
      ) as ItemActiveModel[];
      if (persistColumn) {
        this.itemActiveModelT2 = persistColumn;
      }
      this.eleRef.nativeElement.style.setProperty(
        '--table-min-width',
        this.tableWidthT2 + 'px'
      );
      this.itemActiveModelT2.forEach((element) => {
        this.showHideColumnT2(
          element.itemTitle,
          element.itemWidth,
          element.isActive,
          'OnLoad'
        );
      });
    } else if (this.templateNo == 3) {
      const persistColumn = JSON.parse(
        this.fetchFromBrowser(this.assesment3Type) as string
      ) as ItemActiveModel[];
      if (persistColumn) {
        this.itemActiveModelT3 = persistColumn;
        setTimeout(() => {
          this.itemActiveModelT3.forEach((element) => {
            this.showHideColumnT3(
              element.itemTitle,
              element.itemWidth,
              element.isActive,
              'OnLoad'
            );
          });
        }, 1000);
      }
    } else {
      // Get the elements with the specified classes
      const bodyStyleElement = document.querySelector(
        '.body-style'
      ) as HTMLDivElement;
      const tableElement = document.querySelector('.table') as HTMLDivElement;

      // Check if the elements exist
      if (bodyStyleElement && tableElement) {
        // Set the width for .body-style and .table
        bodyStyleElement.style.width = this.tableWidth + 'px';
        tableElement.style.width = this.tableWidth + 'px';
        bodyStyleElement.style.overflow = 'auto';
      }
      const persistColumn = JSON.parse(
        this.fetchFromBrowser(this.assesmentType) as string
      ) as ItemActiveModel[];
      if (persistColumn) {
        this.itemActiveModel = persistColumn;
      }
      this.eleRef.nativeElement.style.setProperty(
        '--table-min-width',
        this.tableWidth + 'px'
      );
      this.itemActiveModel.forEach((element) => {
        this.showHideColumn(
          element.itemTitle,
          element.itemWidth,
          element.isActive,
          'OnLoad'
        );
      });
    }
    this.fetchCurrentUserRole();
    if (this.templateNo == 2) {
      this.selfAssessmentT2Filter.SortKey = 'AssessmentCreationDate';
      this.selfAssessmentT2Filter.IsDesc = true;
    } else {
      this.selfAssessmentFilter.SortKey = 'CreatedDateTime';
      this.selfAssessmentFilter.IsDesc = true;
    }
    this.fetchSelfAssessmentWithCondition();
    this.removeFromBrowser('_said');
    this.generalService.getDivisionSelected().subscribe(async (res) => {
      const templateNoAfterDivisionChange: number = await this.gdprService
        .getSelfAssessmentTemplate(res)
        .toPromise();
      const previousTemplateNo = this.templateNo;
      this.templateNo = templateNoAfterDivisionChange;
      if (this.templateNo != 3) {
        this.fetchSelfAssessmentWithCondition();
      }
      else {
        if (previousTemplateNo == this.templateNo) {
          this.showT3Summary = false;
          setTimeout(() => this.showT3Summary = true, 0);
          //this.generalService.setSAT3DivisionSelected(res);
        }
      }
    });
  }
  // getSelfAssessmenttableData() {
  //   this.selfAssessmentT3Filter.fromDate = new Date(
  //     this.selfAssessmentT3FilterData.fromDate
  //   );
  //   this.selfAssessmentT3Filter.toDate = new Date(
  //     this.selfAssessmentT3FilterData.toDate
  //   );
  //   this.selfAssessmentT3Filter.assessmentStatus.push(
  //     this.selfAssessmentT3FilterData.assessmentStatus.toString()
  //   );
  //   this.selfAssessmentT3Filter.assessor = this.selfAssessmentT3FilterData.assessor;
  //   this.selfAssessmentT3Filter.owner = this.selfAssessmentT3FilterData.owner;
  //   this.selfAssessmentT3Filter.complianceStatus.push(
  //     this.selfAssessmentT3FilterData.complianceStatus.toString()
  //   );
  //   this.selfAssessmentT3Filter.reviewDate = new Date(
  //     this.selfAssessmentT3FilterData.reviewDate
  //   );
  //   this.selfAssessmentT3Filter.nextAssessmentDue = new Date(
  //     this.selfAssessmentT3FilterData.nextassessmentDue
  //   );
  //   this.selfAssessmentT3Filter.lbcmImpact = Boolean(
  //     this.selfAssessmentT3FilterData.lbcmImpact
  //   );
  //   this.selfAssessmentT3Filter.lbgImpact = Boolean(
  //     this.selfAssessmentT3FilterData.lbgImpact
  //   );
  //   this.selfAssessmentT3Filter.rfbImpact = Boolean(
  //     this.selfAssessmentT3FilterData.rfbImpact
  //   );
  //   this._selfAssessmentTemplate3Service
  //     .getSelfAssessmentT3List(this.selfAssessmentT3Filter)
  //     .subscribe((result: SelfAssessmentT3ViewModel) => {
  //       this.selfAssessmentList = result.data;
  //     });
  // }
  fetchSelfAssessmentWithCondition() {
    if (!this.isPersistFilter) {
      if (this.templateNo == 2) {
        this.gdprService.getOldestDateT2().subscribe((res: string) => {
          if (res) {
            this.oldestCreationDate = res;
            this.selfAssessmentT2Filter.fromDate = this.oldestCreationDate;
            this.fetchSelfAssessmentSummary();
          } else {
            this.fetchSelfAssessmentSummary();
          }
        });
      } else {
        this.gdprService.getOldestDate().subscribe((res: string) => {
          if (res) {
            this.oldestCreationDate = res;
            this.selfAssessmentFilter.fromDate = this.oldestCreationDate;
            this.fetchSelfAssessmentSummary();
          } else {
            this.fetchSelfAssessmentSummary();
          }
        });
      }
    } else {
      this.fetchSelfAssessmentSummary();
    }
  }
  showHideColumn(
    item: string,
    itemWidth: number,
    isHide: boolean,
    filter: string
  ): void {
    switch (item) {
      case 'Assessment Team':
        this.selfAssessmentColumns.assessmentTeam = isHide;
        break;
      case 'Assessor':
        this.selfAssessmentColumns.assessor = isHide;
        break;
      case 'Assessor Delegate':
        this.selfAssessmentColumns.assessorDelegate = isHide;
        break;
      case 'Assessment Due Date':
        this.selfAssessmentColumns.assessmentDueDate = isHide;
        break;
      case 'Assessment Status':
        this.selfAssessmentColumns.assessmentStatus = isHide;
        break;
      case 'Assessment Creation Date':
        this.selfAssessmentColumns.assessmentCreationDate = isHide;
        break;
      case 'Review Team':
        this.selfAssessmentColumns.reviewTeam = isHide;
        break;
      case 'Reviewer':
        this.selfAssessmentColumns.reviewer = isHide;
        break;
      case 'Reviewer Delegate':
        this.selfAssessmentColumns.reviewerDelegate = isHide;
        break;
      case 'Review Due Date':
        this.selfAssessmentColumns.reviewDueDate = isHide;
        break;
      case 'Review status':
        this.selfAssessmentColumns.reviewStatus = isHide;
        break;
      case 'Overall Rule Status':
        this.selfAssessmentColumns.overallStatus = isHide;
        break;
      case 'Conclusion':
        this.selfAssessmentColumns.conclusion = isHide;
        break;
      case 'Owner':
        this.selfAssessmentColumns.owner = isHide;
        break;
      case 'AssessmentLastEdited':
        this.selfAssessmentColumns.assessmentLastEdited = isHide;
        break;
    }

    if (filter === 'Change') {
      if (isHide) {
        this.tableWidth = this.tableWidth + itemWidth;
        this.eleRef.nativeElement.style.setProperty(
          '--table-min-width',
          this.tableWidth + 'px'
        );
      } else if (!isHide) {
        this.tableWidth = this.tableWidth - itemWidth;
        this.eleRef.nativeElement.style.setProperty(
          '--table-min-width',
          this.tableWidth + 'px'
        );
      }
    }
    MasterHelper.saveOnBrowser(
      this.assesmentType,
      JSON.stringify(this.itemActiveModel)
    );
  }
  //For New Self Assessment
  showHideColumnT2(
    item: string,
    itemWidth: number,
    isHide: boolean,
    filter: string
  ): void {
    switch (item) {
      case 'Assessment Category':
        this.selfAssessmentT2Columns.assessmentCategory = isHide;
        break;
      case 'Assessment Due Date':
        this.selfAssessmentT2Columns.assessmentDueDate = isHide;
        break;
      case 'Assessment Team':
        this.selfAssessmentT2Columns.assessmentTeam = isHide;
        break;
      case 'Assessor':
        this.selfAssessmentT2Columns.assessor = isHide;
        break;
      case 'Assessment Status':
        this.selfAssessmentT2Columns.assessmentStatus = isHide;
        break;
      case 'Assessment Creation Date':
        this.selfAssessmentT2Columns.assessmentCreationDate = isHide;
        break;
      case 'Compliance Status':
        this.selfAssessmentT2Columns.complianceStatus = isHide;
        break;
      case 'Interpretation':
        this.selfAssessmentT2Columns.interpretation = isHide;
        break;
      case 'Judgements':
        this.selfAssessmentT2Columns.judgement = isHide;
        break;
      case 'No. of Judgements':
        this.selfAssessmentT2Columns.noOfJudgements = isHide;
        break;
      case 'Limitations':
        this.selfAssessmentT2Columns.gaps = isHide;
        break;
      case 'No. of Limitations':
        this.selfAssessmentT2Columns.noOfGaps = isHide;
        break;
      case 'No. of Limitations Requiring Action':
        this.selfAssessmentT2Columns.noOfGapsRiskAccepted = isHide;
        break;
      case 'Actions':
        this.selfAssessmentT2Columns.enhancement = isHide;
        break;
      case 'No. of Actions':
        this.selfAssessmentT2Columns.noOfEnhancement = isHide;
        break;
      case 'Risk Recommendation':
        this.selfAssessmentT2Columns.riskRecommendation = isHide;
        break;
      case 'Risk Recommendation Status':
        this.selfAssessmentT2Columns.riskRecommendationStatus = isHide;
        break;
      case 'Reviewer Team':
        this.selfAssessmentT2Columns.reviewerTeam = isHide;
        break;
      case 'Reviewer':
        this.selfAssessmentT2Columns.reviewer = isHide;
        break;
      case 'Review Status':
        this.selfAssessmentT2Columns.reviewStatus = isHide;
        break;
      case 'Approval Team':
        this.selfAssessmentT2Columns.approvalTeam = isHide;
        break;
      case 'Approvers':
        this.selfAssessmentT2Columns.approvers = isHide;
        break;
      case 'Approval Status':
        this.selfAssessmentT2Columns.approvalStatus = isHide;
        break;
      case 'Last Approved':
        this.selfAssessmentT2Columns.lastApproved = isHide;
        break;
    }

    if (filter === 'Change') {
      if (isHide) {
        this.tableWidthT2 = this.tableWidthT2 + itemWidth;
        this.eleRef.nativeElement.style.setProperty(
          '--table-min-width',
          this.tableWidthT2 + 'px'
        );
        const bodyStyleElement = document.querySelector(
          '.body-style2'
        ) as HTMLDivElement;
        const tableElement = document.querySelector('.table') as HTMLDivElement;

        // Check if the elements exist
        if (bodyStyleElement && tableElement) {
          // Set the width for .body-style and .table
          bodyStyleElement.style.width = this.tableWidthT2 + 'px';
          tableElement.style.width = this.tableWidthT2 + 'px';
          bodyStyleElement.style.overflow = 'auto';
        }
      } else if (!isHide) {
        this.tableWidthT2 = this.tableWidthT2 - itemWidth;
        this.eleRef.nativeElement.style.setProperty(
          '--table-min-width',
          this.tableWidthT2 + 'px'
        );
        const bodyStyleElement = document.querySelector(
          '.body-style2'
        ) as HTMLDivElement;
        const tableElement = document.querySelector('.table') as HTMLDivElement;

        // Check if the elements exist
        if (bodyStyleElement && tableElement) {
          // Set the width for .body-style and .table
          bodyStyleElement.style.width = this.tableWidthT2 + 'px';
          tableElement.style.width = this.tableWidthT2 + 'px';
          bodyStyleElement.style.overflow = 'auto';
        }
      }
    }
    MasterHelper.saveOnBrowser(
      this.assesment2Type,
      JSON.stringify(this.itemActiveModelT2)
    );
  }

  handler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
  }
  fetchCurrentUserRole(): void {
    this.impactService.getCurrentUserRole().subscribe((data: Role) => {
      this.currentUserRole = data.title;
    });
  }

  fetchSelfAssessmentSummary(): void {
    this.isLoading = true;
    if (this.templateNo == 2) {
      this.gdprService
        .getSelfAssessmentT2(this.selfAssessmentT2Filter)
        .subscribe((result: SelfAssessmentT2ViewModel) => {
          this.newSAItemId = this.fetchFromBrowser('_said')
            ? Number(this.fetchFromBrowser('_said'))
            : 0;
          this.selectedItems = [];
          if (this.newSAItemId > 0) {
            this.selectedItemId = 0;
            this.selectedItems.push(this.newSAItemId);
          }
          this.selfAssessmentT2Summary = result.data;
          this.totalCount = result.totalCount;
          this.isTableLoaded = true;
          this.endIndex =
            this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
          this.removeFromBrowser('_said');
          this.idList = this.getT2IdList();
        });
    } else if (this.templateNo == 1) {
      this.gdprService
        .getSelfAssessment(this.selfAssessmentFilter)
        .subscribe((result: SelfAssessmentViewModel) => {
          this.newSAItemId = this.fetchFromBrowser('_said')
            ? Number(this.fetchFromBrowser('_said'))
            : 0;
          this.selectedItems = [];
          if (this.newSAItemId > 0) {
            this.selectedItemId = 0;
            this.selectedItems.push(this.newSAItemId);
          }
          this.selfAssessmentSummary = result.data;
          this.totalCount = result.totalCount;
          this.isTableLoaded = true;
          this.endIndex =
            this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
          this.removeFromBrowser('_said');
          this.idList = this.getIdList();
        });
    }
    this.isLoading = false;
  }

  duplicateSelfAssessment(id: number, copyType: string): void {
    this.isLoading = true;
    if (this.templateNo == 2) {
      this.gdprService
        .copySelfAssessmentT2(id, copyType)
        .subscribe((data: any) => {
          this.toastModel.Title = 'Success';
          this.toastModel.Type = 'success';
          this.toastModel.Message = data.result;
          this.saveOnBrowser('_said', data.selfAssessmentId);
          this.isToastShow = true;
          setTimeout(() => {
            this.isToastShow = false;
          }, 5000);
          this.fetchSelfAssessmentSummary();
        });
    } else {
      this.gdprService
        .copySelfAssessment(id, copyType)
        .subscribe((data: any) => {
          this.toastModel.Title = 'Success';
          this.toastModel.Type = 'success';
          this.toastModel.Message = data.result;
          this.saveOnBrowser('_said', data.selfAssessmentId);
          this.isToastShow = true;
          setTimeout(() => {
            this.isToastShow = false;
          }, 5000);
          this.fetchSelfAssessmentSummary();
        });
    }
  }

  sortSelfAssessment(key: string): void {
    if (this.templateNo == 2) {
      this.selfAssessmentT2Filter.IsDesc = !this.selfAssessmentT2Filter.IsDesc;
      this.selfAssessmentT2Filter.SortKey = key;
    } else {
      this.selfAssessmentFilter.IsDesc = !this.selfAssessmentFilter.IsDesc;
      this.selfAssessmentFilter.SortKey = key;
    }
    this.fetchSelfAssessmentSummary();
  }

  public scrollRight(): void {
    if (this.templateNo == 2) {
      this.tableContentT2.nativeElement.scrollTo({
        left: this.tableContentT2.nativeElement.scrollLeft + 150,
        behavior: 'smooth',
      });
    } else {
      this.tableContent.nativeElement.scrollTo({
        left: this.tableContent.nativeElement.scrollLeft + 150,
        behavior: 'smooth',
      });
    }
  }

  public scrollLeft(): void {
    if (this.templateNo == 2) {
      this.tableContentT2.nativeElement.scrollTo({
        left: this.tableContentT2.nativeElement.scrollLeft - 150,
        behavior: 'smooth',
      });
    } else {
      this.tableContent.nativeElement.scrollTo({
        left: this.tableContent.nativeElement.scrollLeft - 150,
        behavior: 'smooth',
      });
    }
  }

  selectItem(event: any, id: number): void {
    if (event === 'Checked') {
      this.selectedItems.push(id);
    } else {
      const index = (this.selectedItems as number[]).indexOf(id);
      if (index >= 0) {
        (this.selectedItems as number[]).splice(index, 1);
      }
    }
  }
  receiveData(data: Array<any>) {
    // Handle the received data from the child component
    this.selectedItems = data;
  }

  deleteItem(): void {
    if (this.selectedItems.length > 0) {
      if (this.currentUserRole === 'Compliance Enterprise') {
        this.openDeleteDialog();
      } else {
        let breakFlag = false;
        for (let i = 0; i < this.selectedItems.length; i++) {
          const element = this.selectedItems[i];
          var item = this.selfAssessmentT2Summary.find((a) => a.id == element);
          if (item) {
            if (!this.checkSAT2UserAuth(item)) {
              let message =
                'You are not allowed to delete ' + item.rulebookRuleId;
              this.alertMessageForDeleteOrUpdate(message);
              breakFlag = true;
              break;
            }
          }
        }
        if (!breakFlag) {
          this.openDeleteDialog();
        }
      }
    } else {
      this.alertMessage();
    }
  }

  openDeleteDialog(): void {
    this.alertDialogModel.HeadingText = 'Delete Item';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Delete Item') {
        this.deleteSelfAssessment();
      }
    });
  }

  openCopyDialog(id: number): void {
    this.alertDialogModel.HeadingText = 'Copy Self Assessment';
    this.alertDialogModel.BodyText = 'How do you want to copy?';
    this.alertDialogModel.ActionButtonText = 'Copy';
    this.alertDialogModel.IsAction = true;
    this.alertDialogModel.AlertMsg = 'Copy';

    const dialogRef = this.dialog.open(CopyDialogComponent, {
      width: '450px',
      data: this.alertDialogModel,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'blank') {
        this.duplicateSelfAssessment(id, 'blank');
      } else if (result === 'notblank') {
        this.duplicateSelfAssessment(id, 'notblank');
      }
    });
  }

  deleteSelfAssessment(): void {
    this.showT3Summary = false;
    this.isLoading = true;
    if (this.templateNo == 3) {
      this.selfAssessmentT3Service
        .deleteSummaryT3(this.selectedItems)
        .subscribe((data: any) => {
          this.toastModel.Title = 'Success';
          this.toastModel.Type = 'success';
          this.toastModel.Message = 'Self Assessment deleted successfully';
          this.isToastShow = true;
          setTimeout(() => {
            this.isToastShow = false;
          }, 5000);
          this.selectedItems = [];
          this.fetchSelfAssessmentSummary();
          this, (this.showT3Summary = true);
        });
    } else {
      this.gdprService
        .deleteSelfAssessment(this.selectedItems, this.templateNo)
        .subscribe((data: any) => {
          this.toastModel.Title = 'Success';
          this.toastModel.Type = 'success';
          this.toastModel.Message = data.result;
          this.isToastShow = true;
          setTimeout(() => {
            this.isToastShow = false;
          }, 5000);
          this.selectedItems = [];
          this.fetchSelfAssessmentSummary();
        });
    }
  }

  alertMessage(): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = 'Please select at least one.';
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }
  alertMessageForDeleteOrUpdate(messages: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = messages;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  removeFromBrowser(key: string): any {
    return localStorage.removeItem(key);
  }

  OnFilter(filter: SelfAssessmentFilter): void {
    //Have to change here for new template
    this.selfAssessmentFilter = filter;
    this.isLoading = true;
    this.gdprService
      .getSelfAssessment(filter)
      .subscribe((result: SelfAssessmentViewModel) => {
        this.newSAItemId = this.fetchFromBrowser('_said')
          ? Number(this.fetchFromBrowser('_said'))
          : 0;
        this.selectedItems = [];
        if (this.newSAItemId > 0) {
          this.selectedItemId = 0;
          this.selectedItems.push(this.newSAItemId);
        }
        this.selfAssessmentSummary = result.data;
        this.totalCount = result.totalCount;
        this.isTableLoaded = true;
        this.endIndex =
          this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
        this.removeFromBrowser('_said');
      });
    this.isLoading = false;
  }
  //For new template
  onFilterT3(filter: SelfAssessmentT3Filter): void {
    this.isLoading = true;
    this.showT3Summary = false;
    this.selfAssessmentT3FilterData = filter;
    setTimeout(() => {
      this.showT3Summary = true;
      this.isLoading = false;
    }, 1000);
  }
  OnFilterT2(filter: SelfAssessmentT2Filter): void {
    //Have to change here for new template
    this.selfAssessmentT2Filter = filter;
    this.isLoading = true;
    this.gdprService
      .getSelfAssessmentT2(filter)
      .subscribe((result: SelfAssessmentT2ViewModel) => {
        this.newSAItemId = this.fetchFromBrowser('_said')
          ? Number(this.fetchFromBrowser('_said'))
          : 0;
        this.selectedItems = [];
        if (this.newSAItemId > 0) {
          this.selectedItemId = 0;
          this.selectedItems.push(this.newSAItemId);
        }
        this.selfAssessmentT2Summary = result.data;
        this.totalCount = result.totalCount;
        this.isTableLoaded = true;
        this.endIndex =
          this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
        this.removeFromBrowser('_said');
      });
    this.isLoading = false;
  }

  downloadReport(): void {
    this.isLoading = true;
    if (this.templateNo == 2) {
      this.gdprService.downloadSAReportT2().subscribe(
        (data: any) => {
          this.isLoading = false;
          const a = document.createElement('a'),
            fileURL = URL.createObjectURL(data);
          a.href = fileURL;
          a.download = `ReportTemplate.xlsm`;
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.error(JSON.stringify(err.message));
        }
      );
    }
    else if (this.templateNo == 3) {
      this.gdprService.downloadSAReportT3().subscribe(
        (data: any) => {
          this.isLoading = false;
          const a = document.createElement('a'),
            fileURL = URL.createObjectURL(data);
          a.href = fileURL;
          a.download = `ReportTemplate3.xlsx`;
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.error(JSON.stringify(err.message));
        }
      );
    }
    else {
      this.gdprService.downloadSAReport().subscribe(
        (data: any) => {
          this.isLoading = false;
          const a = document.createElement('a'),
            fileURL = URL.createObjectURL(data);
          a.href = fileURL;
          a.download = `ReportTemplate.xlsm`;
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.error(JSON.stringify(err.message));
        }
      );
    }
  }

  checkSAUserAuth(item: SelfAssessmentListDto): boolean {
    const allUsers = item.assessor
      ? item.assessor
      : '' + ',' + item.assessorDelegate
        ? item.assessorDelegate
        : '' + ',' + item.reviewer
          ? item.reviewer
          : '' + ',' + item.reviewerDelegate
            ? item.reviewerDelegate
            : '';

    if (allUsers) {
      const userArr = allUsers.split(',');
      return userArr.some(
        (a) =>
          (a && a.toLowerCase()) === this.userAccessToken.fullName.toLowerCase()
      );
    } else {
      return false;
    }
  }
  checkSAT2UserAuth(item: SelfAssessmentT2ListDto): boolean {
    let allUsers = item.assessor + ',' + item.reviewer + ',' + item.approvers;
    if (allUsers) {
      const userArr = allUsers.split(',');
      return userArr.some(
        (a) =>
          (a && a.toLowerCase()) === this.userAccessToken.fullName.toLowerCase()
      );
    } else {
      return false;
    }
  }

  bulkUpdate() {
    if (this.selectedItems.length > 1) {
      if (this.templateNo == 2) {
        if (this.currentUserRole === 'Compliance Enterprise') {
          let breakFlag = false;
          for (let i = 0; i < this.selectedItems.length; i++) {
            const element = this.selectedItems[i];
            var item = this.selfAssessmentT2Summary.find(
              (a) => a.id == element
            );
            if (item) {
              if (
                item.approvalStatus == 'Approved' &&
                item.assessmentStatus == 'Approved'
              ) {
                let message =
                  'You are not allowed to update ' +
                  item.rulebookRuleId +
                  ' as it is already Approved';
                this.alertMessageForDeleteOrUpdate(message);
                breakFlag = true;
                break;
              }
            }
          }
          if (!breakFlag) {
            const dialogRef = this.dialog.open(BulkSelfUpdateDialogComponent, {
              width: '1800px',
              height: '850px',
              data: {
                selectedItems: this.selectedItems
              }
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.addBulkUpdateT2(result);
                this.selectedItems = [];
              }
            });
          }
        } else {
          let breakFlag = false;
          for (let i = 0; i < this.selectedItems.length; i++) {
            const element = this.selectedItems[i];
            var item = this.selfAssessmentT2Summary.find(
              (a) => a.id == element
            );
            if (item) {
              if (
                item.approvalStatus == 'Approved' &&
                item.assessmentStatus == 'Approved'
              ) {
                let message =
                  'You are not allowed to update ' +
                  item.rulebookRuleId +
                  ' as it is already Approved';
                this.alertMessageForDeleteOrUpdate(message);
                breakFlag = true;
                break;
              } else {
                if (!this.checkSAT2UserAuth(item)) {
                  let message =
                    'You are not allowed to update ' + item.rulebookRuleId;
                  this.alertMessageForDeleteOrUpdate(message);
                  breakFlag = true;
                  break;
                }
              }
            }
          }
          if (!breakFlag) {
            const dialogRef = this.dialog.open(BulkSelfUpdateDialogComponent, {
              width: '1800px',
              height: '850px',
              data: {
                selectedItems: this.selectedItems
              }
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.addBulkUpdateT2(result);
                this.selectedItems = [];
              }
            });
          }
        }
      } else if (this.templateNo == 3) {
        let breakFlag = false;
        for (let i = 0; i < this.selectedItems.length; i++) {
          const element = this.selectedItems[i];
          let item: SelfAssessmentT3ListDto | undefined =
            this.selfAssessmentList.find((a) => a.id == element);
          // if (item) {
          //   if (item.approvalStatus == "Approved" && item.assessmentStatus == "Approved") {
          //     let message = "You are not allowed to update " + item.rulebookRuleId + " as it is already Approved";
          //     this.alertMessageForDeleteOrUpdate(message);
          //     breakFlag = true;
          //     break;
          //   } else {
          //     if (!this.checkSAT2UserAuth(item)) {
          //       let message = "You are not allowed to update " + item.rulebookRuleId;
          //       this.alertMessageForDeleteOrUpdate(message);
          //       breakFlag = true;
          //       break;
          //     }
          //   }
          // }
        }
        if (!breakFlag) {
          const dialogRef = this.dialog.open(BulkSelfUpdateDialogComponent, {
            width: '1800px',
            height: '850px',
            data: {
              selectedItems: this.selectedItems
            }
          });
        }
      } else {
        const dialogRef = this.dialog.open(BulkSelfUpdateDialogComponent, {
          width: '1800px',
          height: '850px',
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.addBulkUpdate(result);
            this.selectedItems = [];
          }
        });
      }
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
      this.toastModel.Message = 'Select atleast two for Bulk Update';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 3000);
    }
  }
  addBulkUpdate(saDetails: BulkSelfAssessment): void {
    this.bulkUpdateModel.itemIds = this.selectedItems;
    this.bulkUpdateModel.selfAssessment = saDetails;
    this.gdprService
      .sABulkUpdate(this.bulkUpdateModel)
      .subscribe((data: any) => {
        //this.selectedItems = [];
        this.bulkUpdateModel = new BulkSelfUpdateModel();
        this.toastModel.Title = 'Success';
        this.toastModel.Type = 'success';
        this.toastModel.Message = 'Bulk update successfully';
        this.isToastShow = true;
        setTimeout(() => {
          this.isToastShow = false;
        }, 5000);
        this.fetchSelfAssessmentSummary();
      });
  }
  addBulkUpdateT2(saDetails: SelfAssessmentNew): void {
    this.bulkUpdateModelT2.itemIds = this.selectedItems;
    this.bulkUpdateModelT2.selfAssessment = saDetails;
    this.gdprService
      .sABulkUpdateT2(this.bulkUpdateModelT2)
      .subscribe((data: any) => {
        //this.selectedItems = [];
        this.bulkUpdateModelT2 = new BulkSelfUpdateModelT2();
        this.toastModel.Title = 'Success';
        this.toastModel.Type = 'success';
        this.toastModel.Message = 'Bulk update successfully';
        this.isToastShow = true;
        setTimeout(() => {
          this.isToastShow = false;
        }, 5000);
        this.fetchSelfAssessmentSummary();
      });
  }
  public shouldHighlightRow(row: any): boolean {
    return row % 2 == 0 ? false : true;
  }
  redirectLink(id: number) {
    let link = '/self-assessment/details/self/' + id + '';
    const navigationExtras: NavigationExtras = {
      state: { idList: this.idList }
    };
    this.router.navigate([link], navigationExtras);
  }
  redirectLinkT2(id: number) {
    let link = '/self-assessment/details/self/2/' + id + '';
    const navigationExtras: NavigationExtras = {
      state: { idList: this.idList }
    };
    this.router.navigate([link], navigationExtras);
  }
  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }
  allSelectedItems(event: any, dataList: any) {
    this.selectedItems = this._globalService.allSelectedItems(event, dataList);
  }
  showHideColumnT3(
    item: string,
    itemWidth: number,
    isHide: boolean,
    filter: string
  ): void {
    switch (item) {
      // case 'Id':
      //   this.selfAssessmentT3ColumnModel.id = isHide;
      //   break;
      // case 'Rulebook':
      //   this.selfAssessmentT3ColumnModel.Rulebook = isHide;
      //   break;
      // case 'Part':
      //   this.selfAssessmentT3ColumnModel.part = isHide;
      //   break;
      // case 'Rule Id':
      //   this.selfAssessmentT3ColumnModel.ruleId = isHide;
      //   break;
      case 'Rule Owner':
        this.selfAssessmentT3ColumnModel.ruleOwner = isHide;
        break;
      case 'Compliance Status':
        this.selfAssessmentT3ColumnModel.complianceStatus = isHide;
        break;
      case 'Assessment Status':
        this.selfAssessmentT3ColumnModel.assessmentStatus = isHide;
        break;
      case 'Review Date':
        this.selfAssessmentT3ColumnModel.reviewDate = isHide;
        break;
      case 'Assessment Date':
        this.selfAssessmentT3ColumnModel.assessmentDate = isHide;
        break;
      case 'LBG Impact':
        this.selfAssessmentT3ColumnModel.lbgImpact = isHide;
        break;
      case 'RFB Impact':
        this.selfAssessmentT3ColumnModel.rfbImpact = isHide;
        break;
      case 'LBCM Impact':
        this.selfAssessmentT3ColumnModel.lbcmImpact = isHide;
        break;
      case 'Next Assessment Due Date':
        this.selfAssessmentT3ColumnModel.nextAssessmentDueDate = isHide;
        break;
    }
    this._globalService.triggerGearSaT3FunctionCall(itemWidth, isHide, filter, this.itemActiveModelT3);
  }
  summaryTotalDataChange(data: { value1: number, value2: number }) {
    this.totalCount = data.value2;
    this.endIndex = data.value1;
  }
  endIndexUpdate(data: any) {
    this.endIndex = data;
  }
  getT2IdList(): number[] {
    return this.selfAssessmentT2Summary.map(item => item.id);
  }
  getIdList(): number[] {
    return this.selfAssessmentSummary.map(item => item.id);
  }
}
